import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useHistory } from "react-router-dom";
import API_Root from "../../Constants/API_Root";
import { doSignOut } from "../../Authentication/firebase/auth";
import { toggleToast } from "../../Actions/ToggleToast";
import { useDispatch } from "react-redux";
import {authFetch} from "../../Authentication/authService";

const SIDEBAR_WIDTH = 250;

function Shop() {
  const dispatch = useDispatch();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const [hoveredItem, setHoveredItem] = useState(null);
  const history = useHistory();

  const [productDetails, setProductDetails] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedSector, setSelectedSector] = useState("All");

  /* ------------------ API ------------------ */
  useEffect(() => {
    authFetch(API_Root + "admin/fetch-products")
      .then((res) => res.json())
      .then((data) => {
        setProductDetails(data || []);
        setFilteredProducts(data || []);
      })
      .catch((err) => console.error(err));
  }, []);

  /* ------------------ FILTER ------------------ */
  useEffect(() => {
    if (selectedSector === "All") {
      setFilteredProducts(productDetails);
    } else {
      setFilteredProducts(
        productDetails.filter(
          (p) => p.sector?.toLowerCase() === selectedSector.toLowerCase()
        )
      );
    }
  }, [selectedSector, productDetails]);

  const handleLogout = () => {
    doSignOut()
      .then(() => {
        localStorage.removeItem("isLoggedIn");
        history.push("/");
      })
      .catch(() => {
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Logout failed",
          })
        );
      });
  };

  /* ------------------ RESPONSIVE ------------------ */
  useEffect(() => {
    const resize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  /* ------------------ STYLES ------------------ */
  const sidebarStyle = {
    width: SIDEBAR_WIDTH,
    minHeight: "100vh",
    backgroundColor: "#f8f9fa",
    borderRight: "1px solid #e0e0e0",
    padding: "20px",
    position: isDesktop ? "relative" : "fixed",
    top: 0,
    left: isDesktop ? 0 : sidebarOpen ? 0 : -SIDEBAR_WIDTH,
    transition: "left 0.3s ease",
    zIndex: 1000,
  };

  const contentStyle = {
    width: "100%",
    transition: "margin-left 0.3s ease",
  };

  const overlayStyle = {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.3)",
    display: !isDesktop && sidebarOpen ? "block" : "none",
    zIndex: 999,
  };

  const navItemStyle = {
    padding: "10px 15px",
    borderRadius: "6px",
    cursor: "pointer",
    marginBottom: "6px",
  };

  const activeNavItemStyle = {
    ...navItemStyle,
    backgroundColor: "#000",
    color: "#fff",
  };

  const getHoverStyle = (item) => ({
    ...navItemStyle,
    backgroundColor: hoveredItem === item ? "#e6e6e6" : "transparent",
  });

  /* ------------------ ROUTES ------------------ */
  const AccountPage = () => history.push("/profile");
  const ProductPage = () => history.push("/myproduct");
  const SuportPage = () => history.push("/support");
  const TrainingPage = () => history.push("/training");
  const ActivityPage = () => history.push("/activity");

  return (
    <div className="container-fluid p-0">
      {/* Overlay */}
      <div style={overlayStyle} onClick={() => setSidebarOpen(false)} />

      <div className="d-flex">
        {/* ---------------- SIDEBAR ---------------- */}
        <div style={sidebarStyle}>
          <h5 className="fw-bold mb-4 d-flex justify-content-between align-items-center">
            E&S Solutions
            {!isDesktop && (
              <i
                className="bi bi-x-lg"
                style={{ cursor: "pointer" }}
                onClick={() => setSidebarOpen(false)}
              />
            )}
          </h5>

          <div
            style={getHoverStyle("My Products")}
            onMouseEnter={() => setHoveredItem("My Products")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={ProductPage}
          >
            My Products
          </div>

          <div style={activeNavItemStyle}>Shop / Marketplace</div>

          <div
            style={getHoverStyle("Training")}
            onMouseEnter={() => setHoveredItem("Training")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={TrainingPage}
          >
            E&S Solutions Training Centre
          </div>

          <div
            style={getHoverStyle("Support")}
            onMouseEnter={() => setHoveredItem("Support")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={SuportPage}
          >
            Support & Help
          </div>

          <div
            style={getHoverStyle("Account")}
            onMouseEnter={() => setHoveredItem("Account")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={AccountPage}
          >
            Account Settings
          </div>

          <div
            style={getHoverStyle("Activity")}
            onMouseEnter={() => setHoveredItem("Activity")}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={ActivityPage}
          >
            Activity Log
          </div>
        </div>

        {/* ---------------- MAIN CONTENT ---------------- */}
        <div style={contentStyle}>
          <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
            {!isDesktop && (
              <i
                className="bi bi-list fs-3"
                style={{ cursor: "pointer" }}
                onClick={() => setSidebarOpen(true)}
              />
            )}
            <h4 className="fw-bold m-0">Solutions Marketplace</h4>
            <div>
            <button
            className="me-2"
            onClick={handleLogout}
            style={{
              border: "1px solid black",
              backgroundColor: "transparent",
              cursor: "pointer",
              padding: '5px',
              transition: "all 0.3s ease",
              fontSize: "small",
            }}
          >
            Logout
          </button>
              <i className="bi bi-bell me-3" />
              <img
                src="https://alpha.essolutions.ai/static/media/newlogo.b86cf5045d46267faf39.png"
                alt="Profile"
                width="20"
                className="rounded-circle" 
              />
            </div>
          </div>

          <div className="p-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
              <div>
                <h5 className="fw-bold mb-1">E&S Solutions Marketplace</h5>
                <p className="text-muted mb-0">
                  Explore our tools and trainings to enhance your sustainability
                  reporting.
                </p>
              </div>

              <select
                className="form-select mt-3 mt-md-0"
                style={{ width: "170px" }}
                value={selectedSector}
                onChange={(e) => setSelectedSector(e.target.value)}
              >
                <option value="All">All Sectors</option>
                <option value="energy">Energy</option>
                <option value="finance">Finance</option>
                <option value="disclosure">Disclosure</option>
                <option value="team work">Team Work</option>
                <option value="esdd">ESDD</option>
              </select>
            </div>

            <div className="row g-4">
              {filteredProducts.length === 0 && (
                <p className="text-muted">No products found.</p>
              )}

              {filteredProducts.map((item, index) => (
  <div className="col-sm-6 col-md-4 col-lg-3 d-flex" key={index}>
    <div className="card shadow-sm border-0 rounded-4 w-100 d-flex flex-column">
      
      <div className="card-body d-flex flex-column">
        
        <img
          src="https://alpha.essolutions.ai/static/media/newlogo.b86cf5045d46267faf39.png"
          alt="icon"
          width="35"
          className="mb-3"
        />

        <h6 className="fw-bold">{item.product_name}</h6>

        <p
          className="text-muted flex-grow-1"
          style={{
            fontSize: "14px",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
          }}
        >
          {item.product_caption}
        </p>

        <button className="btn btn-success w-100 rounded-3 mt-auto">
          Learn More
        </button>

      </div>
    </div>
  </div>
))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Shop;
